import { Outlet, useLocation } from "react-router";
import { useEffect, useState } from "react";
import Header from "../core/common/header/header";
import BackToTop from "../core/common/backtotop/backToTop";
import Footer from "../core/common/footer/footer";

const Feature = () => {

  const location = useLocation();
  const [isMenuOpened, setIsMenuOpened] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname])

  // Thêm useEffect để theo dõi trạng thái menu
  useEffect(() => {
    const handleMenuStateChange = () => {
      const root = document.documentElement;
      setIsMenuOpened(root.classList.contains("menu-opened"));
    };

    // Theo dõi thay đổi class của html element
    const observer = new MutationObserver(handleMenuStateChange);
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class']
    });

    // Kiểm tra trạng thái ban đầu
    handleMenuStateChange();

    return () => {
      observer.disconnect();
    };
  }, []);

  // Thêm function để đóng menu khi click vào overlay
  const handleOverlayClick = () => {
    if (isMenuOpened) {
      const root = document.documentElement;
      root.classList.remove("menu-opened");
    }
  };
  
  return (
    <>
 
    <div className="main-wrapper">
    <div className={location.pathname === '/index-3' ? 'home-3' : location.pathname === '/index-4' ? 'home-4' : location.pathname === '/index-6' ? 'home-six' : ''}>
            <Header/>
            <Outlet />
            {location.pathname === '/index' || location.pathname === '/index-3' || location.pathname === '/index-4' 
        || location.pathname === '/index-5' || location.pathname === '/index-6' ? <></>:<Footer/>}
            
            <BackToTop/>
          </div>

      <div 
        className={`sidebar-overlay ${isMenuOpened ? 'opened' : ''}`}
        onClick={handleOverlayClick}
      ></div>
    </div>
    </>
  );
};

export default Feature;
